import { useEffect, useState } from "react"
import { useCharacters } from "../../../contexts/Characters"
import { useToaster } from "../../../contexts/Toaster"
import { capitalize } from "../../../utilities/helpers"
import { Roles } from "../../../utilities/constants"
import koalition from "../../../api/koalition"
import Input from '../../forms/Input/Input'
import Radio from "../../forms/Radio/Radio"

const CharactersApprovals = ({ scope }) => {
    const characters = useCharacters()
    const toaster = useToaster()
    const [filterKey, setFilterKey] = useState()
    const [currentStatus, setCurrentStatus] = useState('pending')
    const [visibleCharacters, setVisibleCharacters] = useState()

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'accepted', label: 'Accepted' },
        { value: 'rejected', label: 'Rejected' },
    ]

    const accept = (character, property) => {
        koalition.put(`servers/${characters.$state.current.server._id}/characters/${character._id}/acceptance`, property).then((response) => {
            toaster.success(`Character ${Object.values(property)[0] ? 'accepted' : 'rejected'} successfully`)
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const filterVisibleCharacters = () => {
        const scopeCharacters = ((scope === 'alliance' && characters.authorized([Roles.developer, Roles.admin])) ? characters.$state?.server : characters.$state?.[scope])
        const statusKey = (scope === 'alliance' && characters.authorized([Roles.developer, Roles.admin])) ? `${currentStatus}Alliance` : currentStatus
        const statusCharacters = scopeCharacters?.[statusKey] || []
        const filteredStatusCharacters = statusCharacters.filter((character) => {
            const searchMatch = !filterKey || character.name.toLowerCase().includes(filterKey.toLowerCase())
            const allianceAllowed = scope !== 'alliance' || character.alliance

            return searchMatch && allianceAllowed
        })

        setVisibleCharacters(filteredStatusCharacters)
    }

    useEffect(() => {
        if (characters.$state) filterVisibleCharacters()
    }, [filterKey, currentStatus, characters.$state])

    return (
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col-auto mb-3">
                    <Input onChange={setFilterKey} placeholder="Filter" />
                </div>

                <div className="col-auto mb-3">
                    <Radio options={statusOptions} onChange={setCurrentStatus} />
                </div>
            </div>

            <hr className="mt-2 mb-4" />

            {visibleCharacters && (
                <>
                    {visibleCharacters?.length ? (
                        <ul className="row">
                            {visibleCharacters.map((character) => (
                                <li className="col-sm-6 col-lg-4" key={character._id}>
                                    <div className="card character flex-center-y justify-content-between mb-3">
                                        {characters.authorized([Roles.developer, Roles.admin]) && character.alliance && <span className="chip base aliance mr-3">{character.alliance.tag}</span>}
                                        
                                        <span className="mr-auto">{character.name}</span>
                                        
                                        {(currentStatus === 'pending' || currentStatus === 'accepted') && (
                                            <button className="primary outline medium" onClick={() => accept(character, { [`accepted${capitalize(scope)}`]: false })}>Reject</button>
                                        )}
                                        {(currentStatus === 'pending' || currentStatus === 'rejected') && (
                                            <button className="primary medium ml-2" onClick={() => accept(character, { [`accepted${capitalize(scope)}`]: true })}>Accept</button>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <h3 className="text-center">No pending approval</h3>
                    )}
                </>
            )}
        </div>
    )
}

export default CharactersApprovals